import React from 'react';
import FlatList from './FlatList';
import './TimeslotToggle.sass';

export default ({
  timeslots,
  renderEmpty = () => null,
  formatTime = timeslot => timeslot,
  selectedSlot,
  onSelectSlot,
}) => {
  return (
    <div className="timeslots__wrapper">
      <FlatList
        data={timeslots}
        renderItem={({ item: { name, timeslots: groupedTimeslots }, show = true }) => (
          <div className="day-part__wrapper" key={name}>
            <p className="day-part__title">{name}</p>
            {show ? (
              <FlatList
                data={groupedTimeslots}
                renderItem={({
                  item: [timeslot],
                  select: slotSelect,
                  selected: slotSelected,
                  show: showTimeslot = true,
                }) => {
                  const isExternallySelected = timeslot === selectedSlot;

                  if (isExternallySelected && !slotSelected) {
                    setTimeout(() => slotSelect?.(), 0);
                  }

                  return showTimeslot ? (
                    <button
                      key={timeslot}
                      onClick={() => {
                        slotSelect?.();
                        onSelectSlot?.(timeslot);
                      }}
                      className={`timeslot__btn ${isExternallySelected ? 'm--active' : ''}`}
                    >
                      {` ${formatTime(timeslot)} `}
                    </button>
                  ) : null;
                }}
                renderEmpty={renderEmpty}
              />
            ) : (
              <p className="no-staff-available">Sorry, this filter has returned no results</p>
            )}
          </div>
        )}
      />
    </div>
  );
};
